import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { filterUndefineds } from '@olivierpascal/helpers';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type {
  IApiGetPollsRequestBody,
  IApiGetPollsResponseBody,
} from '../PollsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUsePollsQueryValues = {
  appId: string;
  body?: IApiGetPollsRequestBody;
};

export const pollsQueryKeyFactory: IQueryKeyFactory<IUsePollsQueryValues> = (
  values,
) => values && filterUndefineds(['polls', values.appId, values.body]);

export const usePollsQuery = (
  values?: IUsePollsQueryValues,
  options?: UseQueryOptions<IApiGetPollsResponseBody, ApiError>,
): UseQueryResult<IApiGetPollsResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: pollsQueryKeyFactory(values),
    queryFn: values
      ? () => api.polls.getAll(values.appId, values.body)
      : undefined,
    ...options,
  });
};
